import { DocumentNode, ErrorPolicy, FetchPolicy, LazyQueryResultTuple, OperationVariables, QueryHookOptions, TypedDocumentNode } from '@apollo/client';
import { useEffect, useMemo } from 'react';
import { subscribe } from '../../config/apollo/cache';

type TUseQuerAllProps<TQuery, TVariables extends OperationVariables, TSubscriptionVariables> = {
  fetchPolicy?: FetchPolicy;
  errorPolicy?: ErrorPolicy;
  notifyOnNetworkStatusChange?: boolean;
  WatchQueryFetchPolicy?: FetchPolicy;
  subscriptionDoc?: DocumentNode | TypedDocumentNode;
  subscriptionVariables?: TSubscriptionVariables;
  useQuery: (baseOptions: QueryHookOptions<TQuery, TVariables>) => LazyQueryResultTuple<TQuery, TVariables>;
  variables?: TVariables;
};

export const useQueryAll = <TQuery, TVariables extends OperationVariables, TSubscriptionVariables = undefined>(props: TUseQuerAllProps<TQuery, TVariables, TSubscriptionVariables>) => {
  const { fetchPolicy = 'cache-first', errorPolicy = 'all', notifyOnNetworkStatusChange = true, subscriptionDoc, subscriptionVariables, useQuery, variables } = props;

  //const [loading, setLoading] = useState(true);

  const [fetchData, { data, error, loading, fetchMore, refetch }] = useQuery({
    variables,
    fetchPolicy,
    notifyOnNetworkStatusChange,
    errorPolicy
  });

  const nextToken = useMemo(() => {
    if (data && typeof data === 'object') for (const value of Object.values(data)) if (value && typeof value === 'object' && value.nextToken) return value.nextToken;
    //return null;
  }, [data]);

  useEffect(() => {
    //console.log('useQueryAll():data', data);
    if (data || error) return;
    fetchData();
  }, [data, error, fetchData]);

  useEffect(() => {
    //console.log('useQueryAll():nextToken', nextToken);
    if (!nextToken) return;
    fetchMore({
      variables: {
        nextToken,
        ...(variables || {})
      }
    });
  }, [fetchMore, nextToken, variables]);

  useEffect(() => {
    if (!subscriptionDoc || !subscriptionVariables) return;
    subscribe({
      query: subscriptionDoc,
      variables: subscriptionVariables
    });
  }, [subscriptionDoc, subscriptionVariables]);

  return {
    data,
    error,
    loading,
    refetch
  };
};
